<template>
  <div class="wait-audit" :style="{height: viewportHeight}">
    <HomeHeader scroll-top="300"></HomeHeader>
    <div class="flex-column container w-wrapper">
      <div class="flex-column main">
        <div class="title">企业MCN机构申请</div>
        <div class="steps-box">
          <el-steps :active="4" align-center>
            <el-step title="选择公会类型"></el-step>
            <el-step title="填写公会信息"></el-step>
            <el-step title="填写资质信息"></el-step>
            <el-step title="确认信息"></el-step>
            <el-step title="等待审核"></el-step>
            <el-step title="完成入驻"></el-step>
          </el-steps>
        </div>
        <div v-if="applyStatus === 1" class="flex-column-center form-box">
          <img class="img-status" src="@/assets/apply/submit-success.png" alt="">
          <div class="title-status">提交成功</div>
          <div class="dec">入驻申请提交成功，工作人员将在1-3个工作日内与您联系，请留意！</div>
          <div class="edit-btn">
            <el-button @click="goUpdateForm()">修改资料</el-button>
          </div>
        </div>
        <div v-if="applyStatus === 3" class="flex-column-center form-box">
          <img class="img-status" src="@/assets/apply/audit-fail.png" alt="">
          <div class="title-status">资质信息审核未通过</div>
          <div class="dec">
            <span>很抱歉，你提交的MCN机构入驻资料审核未通过，理由为：</span>
            <span style="color: #f56c6c;">{{ applyDetail.reason }}</span>
          </div>
          <div class="dec">如有需要，请联系平台客服。你可以修改资料重新入职</div>
          <div class="edit-btn">
            <el-button @click="goUpdateForm()">修改资料</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "@/views/home/components/home-header";
import {joinApplyProgress} from "@/apis/audit";
import {getItem} from "@/utils/storage";

export default {
  name: "select-type",
  components: {
    HomeHeader
  },
  data() {
    return {
      applyDetail: {}, // 申请详情
      applyStatus: -1, // 0-未提交 1-审核中 2-审核通过 3-审核未通过 4-已入驻
      applyId: '',
      viewportHeight: '100vh',
      imgCodeUrl: '', // 图形验证码
      imgKey: '', // 图形验证码的key
      ruleForm: {
        contactName: '亚朋', //	负责人姓名	true string
        contactRole: '2', //	负责人身份 1-无 2-区县代理人 3-市级代理人 4-省级代理人		true integer(int32)
        contactPhone: '18513558880',	// 负责人手机号码, aes加密		true string
        smsCode: '', //	短信验证码		true string
        smsKey: '', //	获取验证码时的Key
        contactIdCardFrontUrl: '', 	// 负责人身份证-正面		true string
        contactIdCardBackUrl: '',	// 负责人身份证-背面		true string
        contactIdCard: '312716199809071212',	// 负责人身份证号码		true string
        orgName: '亚朋公会', //	机构名称		true string
        orgDescription: '亚朋公会', // 	机构介绍		true string
        mcnType: '1', //	公会类型 1-企业 2-个人		true integer(int32)
      },
      rules: {
        contactName: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        contactRole: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        contactPhone: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        smsCode: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        contactIdCard: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        orgName: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
        orgDescription: [
          {required: true, message: '请输入', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    if (this.$route.query.mcnType) {
      this.ruleForm.mcnType = this.$route.query.mcnType
    }
    const status = this.$route.query.status || ''
    if (status) {
      this.applyStatus = parseInt(status)
    }
    this.joinApplyProgressApi()
  },
  mounted() {
    let viewportHeight = document.documentElement.clientHeight;
    this.viewportHeight = viewportHeight + 'px'
  },
  methods: {
    // 审核失败，修改资料后重新提交申请
    goUpdateForm() {
      this.$router.push({
        path: '/apply/step-one'
      })
    },
    // 获取入驻进度
    joinApplyProgressApi() {
      const applyId = getItem('applyId')
      if (!applyId) {
        return
      }
      this.applyId = applyId
      joinApplyProgress({applyId: this.applyId}).then(res => {
        const data = res.data || {}
        this.applyDetail = data
        const status = data.status || -1 // 状态 0-草稿 1-待审核 2-审核通过 3-审核失败 4-已退出
        this.applyStatus = status
        if (status === 2 || status === 4) {
          this.$router.push({
            path: '/apply/finish-enter',
            query: {
              status: status
            }
          })
        }
      })
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$router.push({
            path: '/apply/finish-enter'
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    goStepOne(type) {
      this.$router.push({
        path: '/apply/step-one',
        query: {
          mcnType: type
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wait-audit {
  position: relative;
  overflow: hidden;
  background-image: url("~@/assets/banner.png");
  background-size: 100% 600px;
  background-repeat: no-repeat;
}

.container {
  margin: 60px auto 0;
  height: calc(100% - 100px);

  .back {
    padding: 16px 16px 16px 0;
    width: max-content;
    font-size: 16px;
    cursor: pointer;
  }

  .main {
    overflow-y: hidden;
    flex: 1;
    box-sizing: border-box;
    margin-top: 40px;
    padding: 20px;
    border-radius: 4px;
    background-color: #ffffff;

    .steps-box {
      width: 800px;
      margin: 0 auto;
    }

    .form-box {
      flex: 1;
      overflow-y: auto;
      width: 1000px;
      margin: 20px auto 0;
      padding: 120px 20px 20px;

      .img-status {
        width: 130px;
        height: 130px;
      }

      .title-status {
        margin-top: 24px;
        font-size: 20px;
        font-weight: bold;
      }

      .dec {
        font-size: 14px;
        margin-top: 16px;
        text-align: center;
      }

      .edit-btn {
        margin-top: 24px;
      }
    }

    .title {
      margin-bottom: 30px;
      font-size: 24px;
      text-align: center;
      font-weight: bold;
    }

    .type-item {
      margin: 20px 0;
      padding: 10px;
      background-color: #f8f8f8;
      border-radius: 5px;
      border: 1px solid transparent;
      cursor: pointer;

      &:hover {
        border-color: #409EFF;
      }
    }
  }
}
</style>